/**
 * Kalkulator odchudzania: widok.
 *
 * Wszystkie obliczenia robi weight-loss-calculator-logic.js (window.DnnzWeightLossLogic).
 * Ten plik niczego nie dorenderowuje poza wykresem w gotowym <svg>: tabelka
 * przykładów, panel wyniku, blokady i teksty stoją w źródle HTML. Tutaj dzieje
 * się tylko odczyt pól, przełączanie stanów, wstawianie liczb w zdania
 * z atrybutów data-text-*, rysowanie krzywej i przyklejany pasek nawigacji.
 *
 * Konfigurację (liczby) skrypt czyta z atrybutu data-config sekcji, który
 * szablon wypełnia z inc/data/weight-loss.php. Stan nie jest nigdzie zapisywany.
 *
 * Vanilla JS, bez jQuery.
 */
(function () {
	'use strict';

	var SVG_NS = 'http://www.w3.org/2000/svg';

	function toggle(element, visible) {
		if (element) {
			element.hidden = !visible;
		}
	}

	function fill(template, values) {
		return String(template || '').replace(/\{([a-z0-9]+)\}/g, function (match, key) {
			return Object.prototype.hasOwnProperty.call(values, key) ? String(values[key]) : match;
		});
	}

	function fillPercent(value, min, max) {
		if (!(max > min)) {
			return 0;
		}
		return Math.min(100, Math.max(0, ((value - min) / (max - min)) * 100));
	}

	function today() {
		var now = new Date();
		return { y: now.getFullYear(), m: now.getMonth() + 1, d: now.getDate() };
	}

	// --- Wykres ------------------------------------------------------------------

	function svgEl(name, attrs, text) {
		var el = document.createElementNS(SVG_NS, name);
		Object.keys(attrs).forEach(function (key) {
			el.setAttribute(key, attrs[key]);
		});
		if (text !== undefined) {
			el.textContent = text;
		}
		return el;
	}

	/**
	 * Krok podziałki: najmniejszy z listy, przy którym wychodzi najwyżej `max` kresek.
	 */
	function niceStep(span, steps, max) {
		for (var i = 0; i < steps.length; i++) {
			if (span / steps[i] <= max) {
				return steps[i];
			}
		}
		return steps[steps.length - 1];
	}

	/**
	 * series: [{ points: [{day, weight}], kind: 'fixed'|'corrected' }], target: kg albo null.
	 * Oś X w tygodniach, oś Y w kg. viewBox ma szerokość rzeczywistą wykresu
	 * (1 jednostka = 1 px), więc podpisy mają ten sam rozmiar na telefonie i na
	 * komputerze; przy zmianie szerokości okna wykres rysuje się od nowa.
	 */
	function drawChart(svg, series, target, L) {
		while (svg.firstChild) {
			svg.removeChild(svg.firstChild);
		}
		var W = Math.max(240, Math.round(svg.getBoundingClientRect().width) || 320);
		var H = 200;
		svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
		// Góra: miejsce na „kg” nad najwyższą podziałką; dół: podziałki tygodni i „tydzień”.
		var pad = { left: 34, right: 12, top: 28, bottom: 38 };
		var maxDay = 0;
		var lo = Infinity;
		var hi = -Infinity;
		series.forEach(function (s) {
			s.points.forEach(function (p) {
				maxDay = Math.max(maxDay, p.day);
				lo = Math.min(lo, p.weight);
				hi = Math.max(hi, p.weight);
			});
		});
		if (target !== null) {
			lo = Math.min(lo, target);
			hi = Math.max(hi, target);
		}
		var yStep = niceStep(hi - lo, [1, 2, 5, 10, 20, 50], 4);
		lo = Math.floor(lo / yStep) * yStep;
		hi = Math.ceil(hi / yStep) * yStep;
		if (hi === lo) {
			hi = lo + yStep;
		}
		var weeks = Math.max(1, Math.ceil(maxDay / 7));
		var x = function (day) {
			return pad.left + (day / (weeks * 7)) * (W - pad.left - pad.right);
		};
		var y = function (kg) {
			return pad.top + ((hi - kg) / (hi - lo)) * (H - pad.top - pad.bottom);
		};

		// Siatka i podpisy osi Y (kg).
		for (var v = lo; v <= hi + 1e-9; v += yStep) {
			svg.appendChild(svgEl('line', { 'class': 'weight-loss-calculator__chart-grid', x1: pad.left, x2: W - pad.right, y1: y(v), y2: y(v) }));
			svg.appendChild(svgEl('text', { 'class': 'weight-loss-calculator__chart-label', x: pad.left - 6, y: y(v) + 3.5, 'text-anchor': 'end' }, String(v)));
		}
		svg.appendChild(svgEl('text', { 'class': 'weight-loss-calculator__chart-label', x: pad.left - 6, y: 13, 'text-anchor': 'end' }, 'kg'));

		// Podpisy osi X (tygodnie).
		var xStep = niceStep(weeks, [1, 2, 4, 8, 13, 26, 52], 6);
		for (var w = 0; w <= weeks; w += xStep) {
			svg.appendChild(svgEl('text', { 'class': 'weight-loss-calculator__chart-label', x: x(w * 7), y: H - pad.bottom + 14, 'text-anchor': 'middle' }, String(w)));
		}
		svg.appendChild(svgEl('text', { 'class': 'weight-loss-calculator__chart-label', x: W - pad.right, y: H - 5, 'text-anchor': 'end' }, 'tydzień'));

		// Linia celu.
		if (target !== null) {
			svg.appendChild(svgEl('line', { 'class': 'weight-loss-calculator__chart-target', x1: pad.left, x2: W - pad.right, y1: y(target), y2: y(target) }));
			// Podpis celu po lewej: krzywa schodzi do celu dopiero na prawym końcu.
			svg.appendChild(svgEl('text', { 'class': 'weight-loss-calculator__chart-label weight-loss-calculator__chart-label--target', x: pad.left + 6, y: y(target) - 5, 'text-anchor': 'start' }, 'cel ' + L.formatDecimal(target).replace(',0', '') + ' kg'));
		}

		// Krzywe: najpierw korekta (pod spodem), potem ścieżka bez korekty.
		series.slice().reverse().forEach(function (s) {
			var d = s.points.map(function (p, i) {
				return (i === 0 ? 'M' : 'L') + x(p.day).toFixed(1) + ' ' + y(p.weight).toFixed(1);
			}).join(' ');
			svg.appendChild(svgEl('path', { 'class': 'weight-loss-calculator__chart-line weight-loss-calculator__chart-line--' + s.kind, d: d }));
		});
	}

	// --- Kalkulator -------------------------------------------------------------

	function initCalculator(root, L) {
		var cfg;
		try {
			cfg = JSON.parse(root.getAttribute('data-config'));
		} catch (e) {
			return;
		}

		var q = function (selector) {
			return root.querySelector(selector);
		};
		var qa = function (selector) {
			return Array.prototype.slice.call(root.querySelectorAll(selector));
		};

		var CHOICES = ['tempo'];
		var KEYS = ['age', 'height', 'weight', 'target'];
		var inputs = {};
		CHOICES.forEach(function (name) {
			inputs[name] = qa('[data-role="' + name + '"]');
		});
		var numbers = {};
		var ranges = {};
		var fills = {};
		var errors = {};
		KEYS.forEach(function (key) {
			numbers[key] = q('[data-role="' + key + '-number"]');
			ranges[key] = q('[data-role="' + key + '-range"]');
			fills[key] = q('[data-role="' + key + '-fill"]');
			errors[key] = q('[data-role="' + key + '-error"]');
		});

		var result = q('[data-role="result"]');
		var states = {};
		['empty', 'goal', 'minor', 'underweight', 'target-underweight', 'senior-underweight', 'senior-target', 'not-lower', 'too-long'].forEach(function (name) {
			states[name] = q('[data-state="' + name + '"]');
		});
		var bridge = q('[data-role="bridge"]');
		var liveEl = q('[data-role="live"]');

		var goal = {
			lead: q('[data-role="goal-lead"]'),
			date: q('[data-role="goal-date"]'),
			line: q('[data-role="goal-line"]'),
			chart: q('[data-role="goal-chart"]'),
			legend: q('[data-role="legend"]'),
			tiles: q('[data-role="milestones"]'),
			milestones: qa('[data-role="milestone"]')
		};
		var minEls = qa('[data-role="min-target"], [data-role="min-senior"], [data-role="min-senior-target"]');

		if (!result || !states.empty || !states.goal) {
			return;
		}

		// Odświeżenie strony = stan wyjściowy: przeglądarki potrafią przywrócić
		// wpisane wartości, więc na starcie jawnie wracamy do wartości z HTML.
		KEYS.forEach(function (key) {
			if (numbers[key]) {
				numbers[key].value = numbers[key].defaultValue;
			}
		});
		CHOICES.forEach(function (name) {
			inputs[name].forEach(function (input) {
				input.checked = input.defaultChecked;
			});
		});

		function text(el, name) {
			return el.getAttribute('data-text-' + name) || '';
		}

		function weeksWord(n) {
			return L.plural(n, text(result, 'weeks-1'), text(result, 'weeks-2'), text(result, 'weeks-5'));
		}

		function checked(name) {
			for (var i = 0; i < inputs[name].length; i++) {
				if (inputs[name][i].checked) {
					return inputs[name][i];
				}
			}
			return null;
		}

		function value(name) {
			var el = checked(name);
			return el ? el.value : '';
		}

		// Data nie łamie się między wierszami („27 stycznia 2027” w jednym kawałku).
		function nbsp(str) {
			return String(str).replace(/ /g, ' ');
		}

		function kg(n) {
			return L.formatDecimal(n);
		}

		function syncSliders(state) {
			KEYS.forEach(function (key) {
				var range = ranges[key];
				var field = state.fields[key];
				var limits = cfg.limits[key];
				if (!range) {
					return;
				}
				range.classList.toggle('is-empty', field.value === null);
				if (field.value !== null) {
					range.value = Math.min(limits.max, Math.max(limits.min, field.value));
					range.setAttribute('aria-valuetext', numbers[key].value.trim() + ' ' + range.getAttribute('data-unit'));
				} else {
					range.value = limits.min;
					range.setAttribute('aria-valuetext', 'nie podano');
				}
				if (fills[key]) {
					fills[key].style.width = field.value === null ? '0%' : fillPercent(field.value, limits.min, limits.max) + '%';
				}
			});
		}

		function renderGoal(state) {
			var g = state.goal;
			var target = state.fields.target.value;
			var main = g.reached ? { date: g.date, weeks: g.weeks } : { date: g.correctedDate, weeks: g.correctedWeeks };
			var values = {
				n: g.weeks,
				tyg: g.weeks === null ? '' : weeksWord(g.weeks),
				data2: g.correctedDate ? nbsp(g.correctedDate) : '',
				plateau: g.plateau === null ? '' : kg(g.plateau).replace(',0', '')
			};
			// Pod datą najwyżej jedna linia (DECYZJE D23): plateau (albo „ponad 5 lat”),
			// potem druga data, a bez nich „Za N tygodni.”.
			var line = !g.reached ? (g.plateau !== null ? 'line-plateau' : 'line-long')
				: g.showCorrected ? 'line-corrected' : 'line';
			goal.lead.textContent = fill(text(states.goal, g.reached ? 'lead' : 'lead-corrected'), { cel: kg(target).replace(',0', '') });
			goal.date.textContent = main.date;
			// Liczba nie odrywa się od słowa przed nią ani od jednostki: „co 4 tygodnie”, „ok. 86 kg”,
			// „Za 40 tygodni”, „5 lat” zawsze w jednej linii.
			goal.line.textContent = fill(text(states.goal, line), values)
				.replace(/(^|\s)(Za|co|ok\.) (\d)/g, '$1$2\u00a0$3')
				.replace(/(\d) (kg|lat|tydzień|tygodnie|tygodni)/g, '$1\u00a0$2');

			// Druga krzywa i legenda tylko przy drugiej dacie (DECYZJE D15).
			var series = [{ kind: 'fixed', points: g.curve }];
			if (g.showCorrected) {
				series.push({ kind: 'corrected', points: g.correctedCurve });
			}
			drawChart(goal.chart, series, target, L);
			toggle(goal.legend, g.showCorrected);
			goal.chart.setAttribute('aria-label', fill(text(states.goal, !g.reached ? (g.plateau !== null ? 'chart-plateau' : 'chart-long') : g.showCorrected ? 'chart-corrected' : 'chart'), {
				start: kg(state.fields.weight.value).replace(',0', ''),
				cel: kg(target).replace(',0', ''),
				n: g.weeks,
				tyg: values.tyg,
				n2: g.correctedWeeks,
				tyg2: g.correctedWeeks === null ? '' : weeksWord(g.correctedWeeks),
				plateau: values.plateau
			}));

			// Kafelki kamieni milowych: tylko te z datą; jeden na pełną szerokość, zero = bez rzędu (DECYZJE D16).
			var shownTiles = 0;
			goal.milestones.forEach(function (tile, i) {
				var m = g.milestones[i];
				var show = !!(m && m.date);
				toggle(tile, show);
				if (show) {
					shownTiles++;
					tile.querySelector('[data-role="milestone-label"]').textContent = fill(text(states.goal, 'milestone'), {
						proc: L.formatDecimal(m.share * 100).replace(',0', '') + '%',
						masa: kg(m.weight)
					});
					// Dzień z miesiącem razem; w wąskim kafelku rok przechodzi do drugiej linii.
					tile.querySelector('[data-role="milestone-date"]').textContent = m.date.replace(/^(\d+) /, '$1\u00a0');
				}
			});
			toggle(goal.tiles, shownTiles > 0);
			if (goal.tiles) {
				goal.tiles.classList.toggle('is-single', shownTiles === 1);
			}
			return fill(text(states.goal, 'live'), { cel: kg(target).replace(',0', ''), data: main.date });
		}

		function render() {
			var input = {};
			CHOICES.forEach(function (name) {
				input[name] = value(name);
			});
			KEYS.forEach(function (key) {
				input[key] = numbers[key] ? numbers[key].value : '';
			});

			var state = L.evaluate(input, cfg, today());

			KEYS.forEach(function (key) {
				toggle(errors[key], state.fields[key].invalid);
			});
			syncSliders(state);

			var shown = state.blocked || state.notice
				|| (state.hasResult ? 'goal' : 'empty');
			Object.keys(states).forEach(function (name) {
				toggle(states[name], name === shown);
			});
			toggle(bridge, state.hasResult);
			if (state.minTarget !== null) {
				// Od 65 lat próg w pełnych kg (bez „,0”), poniżej 65 lat z dokładnością do 0,1 kg.
				minEls.forEach(function (el) {
					el.textContent = kg(state.minTarget).replace(/,0$/, '');
				});
			}

			var live = '';
			if (state.hasResult) {
				live = renderGoal(state);
			}
			if (liveEl) {
				liveEl.textContent = live;
			}
		}

		KEYS.forEach(function (key) {
			if (numbers[key]) {
				numbers[key].addEventListener('input', render);
			}
			if (ranges[key]) {
				ranges[key].addEventListener('input', function () {
					numbers[key].value = ranges[key].value;
					render();
				});
			}
		});
		CHOICES.forEach(function (name) {
			inputs[name].forEach(function (input) {
				input.addEventListener('change', render);
			});
		});

		// Wykres ma szerokość w pikselach, więc po zmianie szerokości okna rysuje się od nowa.
		var lastWidth = window.innerWidth;
		var resizeTimer = null;
		window.addEventListener('resize', function () {
			if (window.innerWidth === lastWidth) {
				return;
			}
			lastWidth = window.innerWidth;
			window.clearTimeout(resizeTimer);
			resizeTimer = window.setTimeout(render, 120);
		});

		render();
	}

	/**
	 * Nawigacja kotwicowa dokleja się pod header motywu i jedzie z czytelnikiem
	 * do końca strony (jak w spalaniu, nawodnieniu i tkance tłuszczowej).
	 */
	function initStickyNav(root) {
		var nav = root.querySelector('[data-role="nav"]');
		if (!nav) {
			return;
		}

		var header = document.querySelector('.site-header');
		var spacer = document.createElement('div');
		spacer.className = 'weight-loss-calculator__nav-spacer';
		spacer.hidden = true;
		nav.parentNode.insertBefore(spacer, nav);

		var isFixed = false;
		var ticking = false;
		var list = nav.querySelector('ul');
		var links = Array.prototype.slice.call(nav.querySelectorAll('a[href^="#"]'));
		var targets = links.map(function (link) {
			var id = link.getAttribute('href').slice(1);
			return id ? document.getElementById(id) : null;
		});
		var activeIndex = -1;

		function headerOffset() {
			if (!header) {
				return 0;
			}
			var position = window.getComputedStyle(header).position;
			if (position !== 'sticky' && position !== 'fixed') {
				return 0;
			}
			var rect = header.getBoundingClientRect();
			return rect.top <= 0 ? Math.max(0, Math.round(rect.bottom)) : 0;
		}

		function keepVisible(link) {
			if (!list || list.scrollWidth <= list.clientWidth) {
				return;
			}
			var item = link.parentNode.getBoundingClientRect();
			var box = list.getBoundingClientRect();
			var margin = 16;
			if (item.left < box.left + margin) {
				list.scrollLeft += item.left - box.left - margin;
			} else if (item.right > box.right - margin) {
				list.scrollLeft += item.right - box.right + margin;
			}
		}

		function updateActive(offset) {
			if (!links.length) {
				return;
			}
			var line = offset + (isFixed ? nav.getBoundingClientRect().height : 0) + 16;
			var current = -1;
			targets.forEach(function (target, index) {
				if (target && target.getBoundingClientRect().top <= line) {
					current = index;
				}
			});
			if (current !== -1 && targets[current].getBoundingClientRect().bottom < line) {
				for (var j = current + 1; j < targets.length; j++) {
					if (targets[j]) {
						current = j;
						break;
					}
				}
			}
			var atBottom = window.innerHeight + window.pageYOffset >= document.documentElement.scrollHeight - 2;
			if (atBottom) {
				for (var i = targets.length - 1; i >= 0; i--) {
					if (targets[i]) {
						current = i;
						break;
					}
				}
			}
			if (current === activeIndex) {
				return;
			}
			if (links[activeIndex]) {
				links[activeIndex].classList.remove('is-active');
				links[activeIndex].removeAttribute('aria-current');
			}
			activeIndex = current;
			if (links[activeIndex]) {
				links[activeIndex].classList.add('is-active');
				links[activeIndex].setAttribute('aria-current', 'true');
				keepVisible(links[activeIndex]);
			}
		}

		function update() {
			ticking = false;
			var offset = headerOffset();
			root.style.setProperty('--wl-sticky-top', offset + 'px');
			var top = (isFixed ? spacer : nav).getBoundingClientRect().top;
			if (!isFixed && top <= offset) {
				var margin = parseFloat(window.getComputedStyle(nav).marginBottom) || 0;
				spacer.style.height = nav.getBoundingClientRect().height + margin + 'px';
				spacer.hidden = false;
				nav.classList.add('is-fixed');
				isFixed = true;
			} else if (isFixed && top > offset) {
				nav.classList.remove('is-fixed');
				spacer.hidden = true;
				isFixed = false;
			}
			updateActive(offset);
		}

		function onScroll() {
			if (!ticking) {
				ticking = true;
				window.requestAnimationFrame(update);
			}
		}

		window.addEventListener('scroll', onScroll, { passive: true });
		window.addEventListener('resize', onScroll);
		window.addEventListener('load', onScroll);
		update();
	}

	function init() {
		var L = window.DnnzWeightLossLogic;
		var blocks = Array.prototype.slice.call(document.querySelectorAll('[data-weight-loss]'));
		blocks.forEach(function (root) {
			if (L) {
				initCalculator(root, L);
			}
			initStickyNav(root);
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
